import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { boolean, number, object, string, array, mixed, ObjectSchema } from 'yup';
import { Gender } from '../../support/enums';
import { ISaveExpenseType } from '../../shared';

export function useExpenseTypeSchema(): ObjectSchema<ISaveExpenseType> {
    const { t } = useTranslation();
    return useMemo(
        () =>
            object().shape({
                name: string().required(),
                lumpSum: boolean().required(),
                baseLumpSum: number()
                    .typeError(t('invalidNumber'))
                    .optional()
                    .when('lumpSum', { is: true, then: (schema) => schema.required() }),
                lumpSums: array()
                    .of(
                        object().shape({
                            startAge: number().typeError(t('invalidNumber')).required(),
                            amountPerPerson: number().typeError(t('invalidNumber')).required(),
                            gender: mixed<Gender | 'ALL'>().required(),
                        }),
                    )
                    .when('lumpSum', { is: false, then: (schema) => schema.strip() }),
            }),
        [t],
    );
}
